import { render, staticRenderFns } from "./combustion-factors.vue?vue&type=template&id=14d68b4d&scoped=true"
import script from "./combustion-factors.vue?vue&type=script&lang=js"
export * from "./combustion-factors.vue?vue&type=script&lang=js"
import style0 from "./combustion-factors.vue?vue&type=style&index=0&id=14d68b4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d68b4d",
  null
  
)

export default component.exports